class MixMatchBox extends HTMLElement {
  constructor() {
      super();

      this.querySelectorAll('button.close-button, button.close-button--full').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
      this.querySelectorAll('.box-header').forEach((header) =>
        header.addEventListener('click', this.open.bind(this))
      );
    
    this.boxElement = this.querySelector("ul");
    this.price = "";
    this.originalPrice = "";
    this.savings = "";
    this.priceElement = this.querySelector("[data-total]");
    this.originalPriceElement = this.querySelector("[data-original]");
    this.savingsElement = this.querySelector("[data-save]");
    this.MixMatchElement = document.querySelector('mix-match');


  }

  addItemToBox(product) {
    const existingItem = this.boxElement.querySelector(`[data-variant-id="${product.variantId}"]`);

    if (existingItem) {
      // Update quantity and price of the existing item
      const quantityElement = existingItem.querySelector(".box-item__quantity input[type='number']");
      const priceElement = existingItem.querySelector(".box-item__price [data-price]");
      const originalPriceElement = existingItem.querySelector(".box-item__price [data-original-price]");
      
      let quantity = parseInt(quantityElement.value, 10);
      quantity += 1;
      quantityElement.value = quantity;

      const newPrice = product.properties.price * quantity;
      priceElement.textContent = window.Currency.formatMoney(newPrice, window.currencyFormat);

      const newOriginalPrice = product.properties.originalPrice * quantity;
      originalPriceElement.textContent = window.Currency.formatMoney(newOriginalPrice, window.currencyFormat);

    } else {
      // Add a new item if it doesn't exist
      const template = document.querySelector("#box-item-template");

      if (!template) {
        console.error("Template for box items not found!");
        return;
      }

      const itemElement = template.content.cloneNode(true);
      console.log(product);

      itemElement.querySelector(".box-item").setAttribute("data-variant-id", product.variantId);
      itemElement.querySelector(".box-item__title").textContent = product.properties.productTitle;
      itemElement.querySelector(".box-item__quantity input[type='number']").value = "1";
      itemElement.querySelector(".box-item__price [data-price").textContent = window.Currency.formatMoney(product.properties.price, window.currencyFormat);
      itemElement.querySelector(".box-item__price [data-original-price").textContent = window.Currency.formatMoney(product.properties.originalPrice, window.currencyFormat);
      itemElement.querySelector(".box-item__price").dataset.unitPrice = product.properties.price;
      itemElement.querySelector(".box-item__price").dataset.originalPrice = product.properties.originalPrice;
      itemElement.querySelector(".box-item__image").innerHTML = document.querySelector(`#${product.properties.mediaGalleryId} .product__media-item`).innerHTML;
      itemElement.querySelector('.box-item__size').textContent = product.properties.variant;


      const quantityInputElement = itemElement.querySelector("quantity-input");
      if (quantityInputElement) {
        // Listen to the `change` event from the quantity input
        quantityInputElement.addEventListener("change", (event) => {
          this.handleQuantityChange(product.variantId, parseInt(quantityInputElement.input.value, 10), event);
        });
      }



      this.boxElement.appendChild(itemElement);
    }
  }

    removeItemFromBox(variantId) {
    const existingItem = this.boxElement.querySelector(`[data-variant-id="${variantId}"]`);
    if (existingItem) {
      const quantityElement = existingItem.querySelector(".box-item__quantity");
      let quantity = parseInt(quantityElement.textContent, 10);

      if (quantity > 1) {
        // Decrease quantity and update price
        quantity -= 1;
        quantityElement.textContent = quantity;

        const productPrice = parseFloat(existingItem.querySelector(".box-item__price").getAttribute("data-unit-price"));
        existingItem.querySelector(".box-item__price").textContent = window.Currency.formatMoney(productPrice * quantity, window.currencyFormat);
      } else {
        // Remove item entirely if quantity is 1
        existingItem.remove();
      }
    }
      this.MixMatchElement.removeItemFromBox(variantId);
    }
  
  handleQuantityChange(variantId, newQuantity, event) {
    console.log(event);
      const existingItem = this.boxElement.querySelector(`[data-variant-id="${variantId}"]`);
      if (existingItem) {
        const priceElement = existingItem.querySelector(".box-item__price [data-price]");
        const originalPriceElement = existingItem.querySelector(".box-item__price [data-original-price]");
        const productPrice = parseFloat(existingItem.querySelector(".box-item__price").getAttribute("data-unit-price"));
        const originalPrice = parseFloat(existingItem.querySelector(".box-item__price").getAttribute("data-original-price"));
        

        // Calculate current item count and remaining capacity
        const currentItemCount = this.MixMatchElement.getItemCount();
        const remainingCapacity = this.MixMatchElement.maxItems - currentItemCount;
  
        if (newQuantity < 1) {
          this.removeItemFromBox(variantId);
          return;
        }
        console.log(this.MixMatchElement.selectedProducts);



        if (this.MixMatchElement.getItemCount() >= this.MixMatchElement.maxItems) {
          console.log(this.MixMatchElement.selectedProducts);
          // return;
      }
        
  
        // Update the price based on the new quantity
        const newPrice = productPrice * newQuantity;
        priceElement.textContent = window.Currency.formatMoney(newPrice, window.currencyFormat);


        const newOriginalPrice = originalPrice * newQuantity;
        originalPriceElement.textContent = window.Currency.formatMoney(newOriginalPrice, window.currencyFormat);
  
        // Notify MixMatchElement to update the selected products
        this.MixMatchElement.updateProductQuantity(variantId, newQuantity);
      }
    }

  
    updatePrices(selectedProducts) {
      const totalPrice = selectedProducts.reduce((total, product) => 
        total + product.properties.price * product.quantity, 0);
        
      const totalOriginalPrice = selectedProducts.reduce((total, product) => 
        total + product.properties.originalPrice * product.quantity, 0);
        
      const savings = totalOriginalPrice - totalPrice;
    
      this.priceElement.textContent = window.Currency.formatMoney(totalPrice, window.currencyFormat);
      this.originalPriceElement.textContent = `${window.Currency.formatMoney(totalOriginalPrice, window.currencyFormat)}`;
      this.savingsElement.textContent = `${window.Currency.formatMoney(savings, window.currencyFormat)}`;
    }
  
    clearItems() {
      // Find the list element or container holding the items
      const boxItemsContainer = this.querySelector(".box ul");
      
      if (boxItemsContainer) {
        // Remove all child elements (items) from the container
        while (boxItemsContainer.firstChild) {
          boxItemsContainer.removeChild(boxItemsContainer.firstChild);
        }
      }
    
      // Update any prices or counts related to the box
      this.updatePrices([]);
      
      console.log("The mix-match box has been cleared.");
    }

  open() {
      this.classList.add('open');
      this.classList.remove('closed');
  }

  close() {
      this.classList.remove('open');
      this.classList.add('closed');
  }
}

customElements.define('mix-match-box', MixMatchBox);

class MixMatchElement extends HTMLElement {
    constructor() {
      super();
      this.selectedProducts = []; // Stores selected products
        this.bundleId = ""; // Stores the bundle ID
        this.variantId = this.dataset.variant;
      this.identifier = ""; // Unique identifier for the bundle
      this.boxElement = null; // Reference to the box container
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer'); // Cart reference
      this.maxItems = parseInt(this.dataset.max);
      this.mixMatchBox = document.querySelector('mix-match-box');


    }
  
    connectedCallback() {
      // Initialize the element
      this.bundleId = this.getAttribute("data-id");
      this.identifier = `${this.bundleId}_${Date.now()}`;
      this.boxElement = this.querySelector(".box ul");

      this.loadBoxFromLocalStorage();

  
      // Attach event listeners to "add to box" buttons
      this.querySelectorAll('button[name="add"]').forEach((button) => {
        button.addEventListener("click", (e) => this.addToBox(e));
      });
  
      // Attach event listener to "add to cart" button
      this.querySelector(".box button[type='submit']").addEventListener("click", () => this.addToCart());
    }
  
    saveBoxToLocalStorage() {
      localStorage.setItem('mixMatchBox', JSON.stringify(this.selectedProducts));
      console.log("Box saved to localStorage.");
    }
  
  loadBoxFromLocalStorage() {
    return false;
      const savedBox = localStorage.getItem('mixMatchBox');
      if (savedBox) {
        this.selectedProducts = JSON.parse(savedBox);
        this.selectedProducts.forEach((product) => this.mixMatchBox.addItemToBox(product));
        this.updateUI();
        console.log("Box loaded from localStorage.");
      } else {
        console.log("No saved box found in localStorage.");
      }
    }
  
  updateUI() {
    this.updateSubmitButton();
    this.updateItemCount();
    this.updateRangeBar();
    this.updateQuantityButtons();
    this.mixMatchBox.updatePrices(this.selectedProducts);
    if (this.getItemCount() > 0) {
      this.mixMatchBox.classList.remove('empty');
    } else {
      this.mixMatchBox.classList.add('empty');
    }
    if (this.getItemCount() === this.maxItems) {
      
      this.mixMatchBox.open();
    }
    this.updateTitles();
  }

  emptyBox() {
    this.selectedProducts = [];
    this.mixMatchBox.clearItems();
    this.updateUI();
    this.saveBoxToLocalStorage();

    }
  
  updateProductQuantity(variantId, newQuantity) {
      const product = this.selectedProducts.find((product) => product.variantId === variantId);
      if (product) {
        product.quantity = newQuantity;
      }
  
    // Update UI elements
    this.updateUI();
    this.saveBoxToLocalStorage();

    }
  
  removeItemFromBox(variantId) {
    const productIndex = this.selectedProducts.findIndex(product => product.variantId === variantId);
    if (productIndex > -1) {
      const product = this.selectedProducts[productIndex];
      if (product.quantity > 1) {
        product.quantity -= 1;
      } else {
        this.selectedProducts.splice(productIndex, 1);
      }
    }

    // Update UI
    console.log('removefrombox');
    this.updateUI();
    this.saveBoxToLocalStorage();


  }

  
    addToBox(event) {
        const button = event.target;
        const variantId = parseInt(button.closest('form').querySelector('input[name="id"]').value);
        const parentVariant = button.closest(".product-variant");
        const productParent = button.closest(".product");
        const categoryElement = button.closest(".category");
        const categoryTitle = categoryElement.dataset.title;
        const maxItems = this.maxItems;
  
      
      

    
        if (this.getItemCount() >= maxItems) {
            alert(`You can only add up to ${maxItems} items from the "${categoryTitle}" category.`);
            return;
        }
    
      const productTitle = productParent.querySelector(".card-information__text").textContent;
      let variant = '';
      if (productParent.querySelector('select')) {
        variant = productParent.querySelector('select').value;
      }
      const activeVariantPriceElement = productParent.querySelector('.variant-prices [data-variant]:not(.hidden)');
      const price = parseFloat(activeVariantPriceElement.dataset.price);
      const originalPrice = parseFloat(activeVariantPriceElement.dataset.originalPrice);
      const mediaGalleryId = productParent.querySelector('.card__media-gallery').id;
    
        const product = {
            variantId,
            quantity: 1,
            category: categoryTitle, // Category title as defined in the category div
            type: "product", // Default type
            properties: {
                productTitle,
                price,
                originalPrice,
                variant,
                mediaGalleryId
            },
        };
    
      this.selectedProducts.push(product);
    
      this.mixMatchBox.addItemToBox(product);        


      
      this.updateUI();
      this.mixMatchBox.updatePrices(this.selectedProducts);
      this.saveBoxToLocalStorage();

    
    }
  
    getItemCount() {
      return this.selectedProducts.reduce((total, product) => total + product.quantity, 0);
    }
  
  updateQuantityButtons() {
    const quantityInputs = this.querySelectorAll('quantity-input');
    const itemCount = this.getItemCount();
    const remainingItems = this.maxItems - itemCount;
    if (remainingItems === 0) {

      quantityInputs.forEach((quantityInput) => {
        quantityInput.querySelector('button[name="plus"]').disabled = true;
      });
      
    } else {
      quantityInputs.forEach((quantityInput) => {
        quantityInput.querySelector('input[type="number"]').max = this.maxItems;
        quantityInput.querySelector('button[name="plus"]').disabled = false;
      });
    }
    }
  
    updateTitles() {
      const completeTitle = this.querySelector('.complete-title');
      const singleTitle = this.querySelector('.single-title');
      const defaultTitle = this.querySelector('.default-title');
    
      const itemCount = this.getItemCount();
      const remainingItems = this.maxItems - itemCount;
      const maxItems = this.maxItems;
    

      [completeTitle, singleTitle, defaultTitle].forEach((title) => {
        if (title) title.classList.add('hidden');
      });
    
      switch (true) {
        case itemCount === maxItems && !!completeTitle:
          completeTitle.classList.remove('hidden');
          break;
        case remainingItems === 1 && !!singleTitle:
          singleTitle.classList.remove('hidden');
          break;
        case remainingItems > 1 && !!defaultTitle:
          defaultTitle.classList.remove('hidden');
          const span = defaultTitle.querySelector('span');
          if (span) {
            span.textContent = `${remainingItems}`;
          }
          break;
        default:
          console.log('Default case: No matching condition');
          break;
      }
    }
  
  updateSubmitButton() {
    const maxItems = this.maxItems;
    const totalQuantity = this.getItemCount();
    const submitButton = this.querySelector('mix-match-box button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = totalQuantity < maxItems;
    }
  }
  
  
  updateRangeBar() {
    this.rangeElement = this.querySelector('mix-match-box .range__inner');
      if (this.rangeElement) {
        const totalQuantity = this.getItemCount();
        const percentage = (totalQuantity / this.maxItems) * 100;
        this.rangeElement.style.width = `${Math.min(percentage, 100)}%`;
      }
    }
  
    updateItemCount() {
      const totalQuantity = this.getItemCount();

      const countElements = document.querySelectorAll('span[data-count]');
      countElements.forEach((element) => {
        element.textContent = totalQuantity;
      });
    }
  
    async addToCart() {
      if (this.getItemCount() === 0) {
        alert("No products in the box to add to the cart.");
        return;
      }
    
      // Ensure the bundle variant ID is correctly set
      const bundleVariantId = this.variantId; // Replace with the actual bundle variant ID
    
      if (!bundleVariantId) {
        console.error("Bundle variant ID is not defined.");
        return;
      }
    
      // Construct the FoxSell dynamic bundle items
      const bundleLineItemProperties = this.selectedProducts.map((product) => ({
        variantId: product.variantId,
        quantity: product.quantity,
        category: product.category,
        type: product.type,
      }));
    
      console.log("Bundle Line Item Properties:", JSON.stringify(bundleLineItemProperties));
    
      // Prepare the payload for Shopify's cart API
      const addToCartFormData = {
        items: [
          {
            id: bundleVariantId,
            quantity: 1, // Quantity of the bundle itself
            properties: {
              "__foxsell:dynamic_add_on_bundle_id": this.identifier,
              "__foxsell:dynamic_add_on_bundle_items": JSON.stringify(bundleLineItemProperties),
            },
          },
        ],
      };
    
      // Log the request body for debugging
      console.log("addToCartFormData:", addToCartFormData);
    
      // Prepare fetch configuration
      const config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          ...addToCartFormData,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      };
    
      try {
        const response = await fetch('/cart/add.js', config);
    
        if (!response.ok) {
          const errorText = await response.text();
          console.error("Server error:", response.statusText, errorText);
          throw new Error("Failed to add to cart");
        }
    
        const result = await response.json();
    
        if (result.status) {
          this.handleErrorMessage(result.description);
          return;
        }
    
        this.mixMatchBox.close();
        this.emptyBox();
        this.cart.renderContents(result);
      } catch (error) {
        console.error("Error adding to cart:", error);
      } finally {
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) {
          spinner.classList.add('hidden');
        }
      }
    }
  
    handleErrorMessage(errorMessage = false) {
      const errorMessageWrapper = this.querySelector('.box .error-message-wrapper');
      const errorMessageElement = errorMessageWrapper?.querySelector('.error-message');
  
      if (errorMessageWrapper && errorMessageElement) {
        errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) errorMessageElement.textContent = errorMessage;
      }
    }
  }
  
  // Define the custom element
customElements.define("mix-match", MixMatchElement);
  
class BoxOpener extends HTMLElement {
  constructor() {
      super();
      this.addEventListener('click', this.openBox);
      
  }

  openBox() {
      const mixMatchBox = document.querySelector('mix-match-box');
      if (mixMatchBox) {
          mixMatchBox.open();
      }
  }
}

customElements.define('box-opener', BoxOpener);


